import { defineMessages } from 'react-intl'

export default defineMessages({
  voiceLine: {
    id: 'containers.CustomerOrderUpsertPage.components.AiVoiceLines.voiceLine',
    defaultMessage: 'AI script',
  },
  tableHeaderVoiceLine: {
    id: 'containers.CustomerOrderUpsertPage.components.AiVoiceLines.tableHeaderVoiceLine',
    defaultMessage: 'Scripts',
  },
  addLine: {
    id: 'containers.CustomerOrderUpsertPage.components.AiVoiceLines.addLine',
    defaultMessage: 'Add script',
  },
  noVoiceLines: {
    id: 'containers.CustomerOrderUpsertPage.components.AiVoiceLines.noVoiceLines',
    defaultMessage: 'No voice lines',
  },
  delete: {
    id: 'containers.CustomerOrderUpsertPage.components.AiVoiceLines.delete',
    defaultMessage: 'Delete',
  },
  deleteConfirm: {
    id: 'containers.CustomerOrderUpsertPage.components.AiVoiceLines.deleteConfirm',
    defaultMessage: 'Are you sure you want to delete this script?',
  },
  generating: {
    id: 'containers.CustomerOrderUpsertPage.components.AiVoiceLines.generating',
    defaultMessage: 'Generating...',
  },
  reGenerate: {
    id: 'containers.CustomerOrderUpsertPage.components.AiVoiceLines.reGenerate',
    defaultMessage: 'Regenerate',
  },
  listen: {
    id: 'containers.CustomerOrderUpsertPage.components.AiVoiceLines.listen',
    defaultMessage: 'Listen',
  }
})